import request from '@/utils/requests'
import qs from 'qs'

// 错误上报
export const webLog = data => {
    return request({
        url: '/log/web',
        method: 'post',
        data:qs.stringify(data)
    })
}

export const siteReport = data => {
    return request({
        url: '/v2/site_report',
        method: 'get',
        params: data
    })
}
